export const VENUE_ONBOARDING_INTENT = 'venue'
export const VENUE_ONBOARDING_PATH = '/onboarding'

export function getOnboardingContinuation(url: URL | string): string {
    const parsedUrl = typeof url === 'string' ? new URL(url) : url
    return parsedUrl.searchParams.get('intent') === VENUE_ONBOARDING_INTENT ? VENUE_ONBOARDING_PATH : '/authenticated-entry'
}
